import { Node } from "../../node.js";
/**
 * @public
 */
export function hasDescendant(predicate, options = Node.Traversal.empty) {
    return (node) => node.descendants(options).some(predicate);
}
//# sourceMappingURL=has-descendant.js.map